// extracted by mini-css-extract-plugin
module.exports = {"separator":"widget-space--separator--thZ68","informative":"widget-space--informative--16lgT","separatorText":"widget-space--separatorText--2OnDL"};